import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { CheckCircle2, XCircle, Clock, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function SubscriptionSuccessPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const nav = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    if (!sessionId) { setStatus("no_session"); return; }
    let ok = false;
    let cancelled = false;
    const poll = async (i) => {
      if (cancelled) return;
      try {
        const { data } = await api.get(`/subscription/checkout-status/${sessionId}`);
        setAttempts(i + 1);
        if (data.payment_status === "paid") { setStatus("paid"); ok = true; return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("failed"); return; }
      } catch (_) { /* keep polling */ }
      if (i >= 20) { setStatus("timeout"); return; }
      setTimeout(() => poll(i + 1), 2000);
    };
    poll(0);
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <div className="mx-auto max-w-md p-8 text-center">
      {status === "polling" && (
        <>
          <Clock className="mx-auto h-16 w-16 text-[#0052FF] animate-pulse" />
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Verifica pagamento...</h1>
          <p className="mt-2 text-sm text-slate-500">{t("auto.attendo_conferma_da_stripe_tentativo_attempts_120")}</p>
        </>
      )}
      {status === "paid" && (
        <>
          <CheckCircle2 className="mx-auto h-16 w-16 text-emerald-600" />
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Pagamento confermato!</h1>
          <p className="mt-2 text-sm text-slate-500">{t("auto.il_tuo_abbonamento_è_attivo_grazie")}</p>
          <Button onClick={() => nav("/")} className="mt-6 rounded-sm bg-[#0052FF] hover:bg-[#0040CC]" data-testid="btn-go-dashboard">
            Vai alla dashboard <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </>
      )}
      {status === "failed" && (
        <>
          <XCircle className="mx-auto h-16 w-16 text-red-600" />
          <h1 className="mt-4 text-2xl font-bold text-slate-900">{t("auto.pagamento_non_riuscito")}</h1>
          <p className="mt-2 text-sm text-slate-500">{t("auto.riprova_o_contatta_il_supporto")}</p>
          <Button onClick={() => nav("/abbonamento")} className="mt-6 rounded-sm" variant="outline">Torna ai piani</Button>
        </>
      )}
      {status === "timeout" && (
        <>
          <Clock className="mx-auto h-16 w-16 text-amber-600" />
          <h1 className="mt-4 text-2xl font-bold text-slate-900">Verifica in corso</h1>
          <p className="mt-2 text-sm text-slate-500">{t("auto.il_pagamento_potrebbe_essere_in_elaborazione_ricontrolla_tra")}</p>
          <Button onClick={() => nav("/abbonamento")} className="mt-6 rounded-sm">Ricarica</Button>
        </>
      )}
      {status === "no_session" && (
        <>
          <XCircle className="mx-auto h-16 w-16 text-slate-400" />
          <h1 className="mt-4 text-2xl font-bold text-slate-900">{t("auto.sessione_non_valida")}</h1>
          <Button onClick={() => nav("/abbonamento")} className="mt-6 rounded-sm">Torna ai piani</Button>
        </>
      )}
    </div>
  );
}
